import React, { PropTypes } from 'react'
// import moment from 'moment'
import { format } from 'date-fns'
import Card from 'components/Card'
import styles from './UploadLogs.scss'
import constants from 'constants'

const UploadLogs = ({
  documentsArray, title, backToAdminCentreText, isAdmin,
}) => {
  if (documentsArray.length > 0) {
    return (
      <div>
        <Card noPadding >
          {documentsArray.map((doc, key) =>
          (<div className={styles.rowWrapper} key={key}>
            <div className={styles.summary}>
              <span>Date: { format(Date.parse(doc.LoggedDate), constants.DATE_FORMAT.STANDARD_FULLMONTH) }</span><br />
              <span>Files processed: {doc.FilesProcessed}</span><br />
              <span>Files successfully uploaded: {doc.FilesSuccessful}</span><br />
              <span>Failed uploads: {doc.FilesFailed}</span><br />
            </div>
            <a className={styles.viewText} href={doc.URL} target="_blank">VIEW REPORT</a>
          </div>))}
        </Card>
      </div>
    )
  }

  return (
    <div>
      <Card><div>No upload status found</div></Card>
    </div >
  )
}
UploadLogs.propTypes = {
  title: PropTypes.string.isRequired,
  documentsArray: PropTypes.array.isRequired,
}

export default UploadLogs



// WEBPACK FOOTER //
// ./src/components/UploadLogs/UploadLogs.js